/** Все идентификаторы: UUID v7 в виде строки. Алиасы нужны для читаемости контрактов. */
export type SalonId = string;
export type UserId = string;
export type MasterId = string;
export type ServiceId = string;
export type ClientId = string;
export type BookingId = string;
export type ConversationId = string;
export type MessageId = string;
export type NotificationId = string;

/** Канал общения с клиентом. `demo`: наш веб-чат для демо на встрече и тестов, данные не считаются реальными. */
export const Channels = ["instagram", "demo"] as const;
export type Channel = (typeof Channels)[number];

/** Роли в салоне. Наша админка: отдельный флаг пользователя, не роль в салоне. */
export const SalonRoles = ["owner", "master"] as const;
export type SalonRole = (typeof SalonRoles)[number];

/** Языки бота и интерфейса. sr-Latn: сербский латиницей, sr-Cyrl: кириллицей. */
export const Locales = ["sr-Latn", "sr-Cyrl", "en", "ru"] as const;
export type Locale = (typeof Locales)[number];
